import type { FC } from 'react';
import Modal from '@/components/Modal';
import { ExternalLinkIcon } from '@/components/icons/ExternalLinkIcon';
import { useTranslation } from 'react-i18next';

type PeriodLockedModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onGoPlans: () => void;
    /** 省略時は既定。分析カスタムピッカー（高 z-index）の上に載せるときに指定 */
    overlayZIndex?: number;
};

/**
 * 期間選択機能がロックされていることを案内するモーダル
 */
export const PeriodLockedModal: FC<PeriodLockedModalProps> = ({
    isOpen,
    onClose,
    onGoPlans,
    overlayZIndex,
}) => {
    const { t } = useTranslation('search');

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            contentClassName="w-full max-w-md p-6"
            zIndex={overlayZIndex}
        >
            <div className="space-y-8">
                <h3 className="text-lg font-semibold text-center">
                    {t('periodLocked.title')}
                </h3>
                <div
                    className="text-sm text-gray-700 leading-relaxed text-left [&_strong]:font-semibold [&_strong]:mt-3 [&_strong]:mb-2 [&_strong]:block [&_p]:text-gray-700 [&_ul]:list-disc [&_ul]:list-inside [&_ul]:mt-2 [&_ul]:mb-2 [&_ul]:pl-1 [&_li]:mb-1 [&_li]:leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: t('periodLocked.message') }}
                />
                <div className="flex justify-center mt-4">
                    <button
                        type="button"
                        className="px-6 py-2 rounded-md bg-kotomilThemaColor text-black hover:bg-kotomilThemaColor/90 text-sm inline-flex items-center gap-2"
                        onClick={() => {
                            onClose();
                            onGoPlans();
                        }}
                    >
                        <span>{t('periodLocked.cta')}</span>
                        <ExternalLinkIcon className="h-5 w-5" />
                    </button>
                </div>
            </div>
        </Modal>
    );
};

